// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientAccountModel {
    static getAttributeTypeMap() {
        return PatientAccountModel.attributeTypeMap;
    }
}
PatientAccountModel.discriminator = undefined;
PatientAccountModel.additionalProperties = false;
PatientAccountModel.attributeTypeMap = [
    {
        "name": "account",
        "baseName": "account",
        "type": "AccountModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PatientModel"
    },
    {
        "name": "ssn",
        "baseName": "ssn",
        "type": "string"
    },
];
//# sourceMappingURL=patientAccountModel.js.map